<div class="assign">

  <!-- ── Point de mesure ──────────────────────────────────────────────────── -->
  <div class="assign-card">
    @if (isControlPointAssigned()) {
      <div class="assign-card__value">{{ assignedControlPoint()?.name }}</div>
      <div class="assign-card__label">
        <img src="assets/icon/control-point-black.svg" alt="" />
        {{ 'VIBRATION.MEASUREMENT_POINT' | translate }}
      </div>

      <div class="assign-card__actions">
        <app-button variant="secondary" size="xsmall" [addIconLeft]="true"
          [label]="'BUTTONS.MODIFY' | translate" (clicked)="modifyAssignedCp()">
          <img slot="icon-left" src="assets/icon/pencil.svg" alt="" />
        </app-button>
        <app-button variant="tertiary" size="xsmall" [addIconLeft]="true"
          [label]="'BUTTONS.UNASSIGN' | translate" (clicked)="unassignRecord('controlPoint')">
          <img slot="icon-left" src="assets/icon/delete.svg" alt="" />
        </app-button>
      </div>
    } @else {
      <div class="assign-card__value">
        {{ (canCancel() ? 'VIBRATION.MODIFY_MEASUREMENT_POINT' : 'VIBRATION.NO_MEASUREMENT_POINT') | translate }}
      </div>

      <app-autocomplete
        [data]="controlPointNodes()"
        [placeholder]="placeholderCp | translate"
        (selected)="onCpNodeSelected($event)">
      </app-autocomplete>

      <div class="assign-card__actions">
        @if (canCancel()) {
          <app-button variant="tertiary" size="xsmall"
            [label]="'BUTTONS.CANCEL' | translate" (clicked)="cancel('controlPoint')">
          </app-button>
        }
        <app-button variant="primary" size="xsmall"
          [label]="'BUTTONS.ASSIGN' | translate" (clicked)="assignRecord('controlPoint')">
        </app-button>
      </div>
    }
  </div>

  <!-- ── Device ───────────────────────────────────────────────────────────── -->
  <div class="assign-card">
    <div class="assign-card__value">{{ deviceRef() }}</div>
    <div class="assign-card__label">
      <img src="assets/icon/device.svg" alt="" />
      {{ 'VIBRATION.DEVICE' | translate }}
    </div>
  </div>

</div>
